import { Component, inject, viewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ComponentMap, RendererService } from '../../services/renderer.service';
import { LanguageService } from '../../services/language.service';

const COMPONENT_MAP: ComponentMap = {
    ComponentMainStart: import('../../components/start/start.component').then(
        (m) => m.StartComponent,
    ),
    ComponentMainNotFound: import(
        '../../components/common/not-found/not-found.component'
    ).then((m) => m.NotFoundComponent),
} as { [key: string]: any };

@Component({
    selector: 'app-start-renderer',
    imports: [],
    templateUrl: './start-renderer.component.html',
})
export class StartRendererComponent {
    viewContainerRef = viewChild('viewContainerRef', {
        read: ViewContainerRef,
    });
    private languageService = inject(LanguageService);
    private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
    private rendererService: RendererService = inject(RendererService);

    ngOnInit() {
        this.activatedRoute.params.subscribe((params) => {
            if (params['langaugeCode'] === 'en') {
                this.languageService.changeLanguage('en');
            }
        });
        this.activatedRoute.data.subscribe((response: any) => {
            const data = response.page;
            this.rendererService.viewContainerRef.set(this.viewContainerRef());
            this.rendererService.loadComponents(
                data,
                COMPONENT_MAP,
                'Start',
                undefined,
            );
        });
    }
}
